import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtTxtNum from "../Components/CustomTool/CtTxtNum";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import TableList from "./CustomTool/TableList";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class AMCFollowUpEntry extends Component {
  state = {
    formData: {
      bint_followup_srno: 1,
      dtpFollowUpDate: get_YMD_from_SYS(new Date()),
      txtPersonName: "",
      txtNumber: "",
      txtDiscussion: "",
      dtpReminderDate: get_YMD_from_SYS(new Date()),
      txtRemark: "",
    },
    Columns: [
      {
        id: "selected",
        label: "",
        type: "Chk",
        CtrlProps: { label: "" },
        headertype: "Chk",
        headerCtrlProps: { label: "", value: false },
      },
      { id: "docNo", label: "Document No" },
    ],
    rows: [
      { ID: 1, docNo: "TOP/AMC/BVN/25-26/03", selected: false },
      { ID: 2, docNo: "TOP/AMC/BVN/25-26/04", selected: false },
      { ID: 3, docNo: "TOP/AMC/BVN/25-26/05", selected: false },
    ],
    ARD: null,
  };

  componentDidMount() {
    document.title = "AMC Follow Up Entry";
    localStorage.setItem("Heading", "AMC Follow Up Entry");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("dtpFollowUpDate").focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnRowDataChange = (rows) => {
    const allSelected =
      rows.length > 0 && rows.every((row) => row.selected === true);
    const Columns = this.state.Columns.map((col) => {
      if (col.id === "selected") {
        return {
          ...col,
          headerCtrlProps: {
            ...col.headerCtrlProps,
            value: allSelected,
          },
        };
      }
      return col;
    });
    this.setState({ rows, Columns });
  };

  handleOnColumnChange = (columns) => {
    this.setState({ Columns: columns });
  };

  validateFollowUpEntry = () => {
    const {
      dtpFollowUpDate,
      txtPersonName,
      txtNumber,
      txtDiscussion,
      dtpReminderDate,
    } = this.state.formData;

    if (!dtpFollowUpDate) {
      this.props.toastErrorMsg("Select Date", "dtpFollowUpDate");
      return false;
    }
    if (!txtPersonName) {
      this.props.toastErrorMsg("Enter Person Name", "txtPersonName");
      return false;
    }
    if (!txtNumber || txtNumber.length !== 10) {
      this.props.toastErrorMsg("Enter 10 Digit Number", "txtNumber");
      return false;
    }
    if (!txtDiscussion) {
      this.props.toastErrorMsg("Enter Discussion", "txtDiscussion");
      return false;
    }
    if (!dtpReminderDate) {
      this.props.toastErrorMsg("Select Remainder Date", "dtpReminderDate");
      return false;
    }
    return true;
  };

  saveFollowUpEntry = () => {
    if (this.validateFollowUpEntry()) {
      this.props.toastMsg("success", "Follow Up Save Successfully");
      this.clearInfo();
    }
  };

  clearInfo = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        bint_followup_srno: 1,
        dtpFollowUpDate: get_YMD_from_SYS(new Date()),
        txtPersonName: "",
        txtNumber: "",
        txtDiscussion: "",
        dtpReminderDate: get_YMD_from_SYS(new Date()),
        txtRemark: "",
      },
      ARD: null,
      rows: this.state.rows.map((row) => ({
        ...row,
        selected: false,
      })),
    });
    document.getElementById("dtpFollowUpDate").focus();
  };

  DeleteData = (bint_followup_srno, vac_personname) => {
    if (bint_followup_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_personname} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteFollowUpEntry();
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteFollowUpEntry = () => {
    this.props.toastMsg("success", "Follow Up Delete Successfully");
    this.clearInfo();
  };

  render() {
    return (
      <form>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCList">
            AMC List
          </Link>{" "}
          <Link underline="hover" color="inherit" href="#/AMCRegistration">
            AMC Registration
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCFollowUpList">
            Follow Up List
          </Link>
          <Typography sx={{ color: "text.primary" }}>
            Follow Up Entry
          </Typography>
        </Breadcrumbs>

        <Grid container spacing={2} marginTop={2}>
          {/* <Grid item>
            <CtTxt
              id="bint_followup_srno"
              label="Follow up SrNo"
              value={this.state.formData.bint_followup_srno}
              disabled={true}
              width={180}
            />
          </Grid> */}
          <Grid item>
            <CtDtp
              id="dtpFollowUpDate"
              label="Date*"
              value={this.state.formData.dtpFollowUpDate}
              handleOnChange={this.handleOnChange}
              width={180}
              maxLength={100}
              nextCtrlID={"txtPersonName"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtPersonName"
              label="Person Name*"
              value={this.state.formData.txtPersonName}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              nextCtrlID={"txtNumber"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtTxtNum
              id="txtNumber"
              label="Number*"
              value={this.state.formData.txtNumber}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              nextCtrlID={"txtDiscussion"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item xs={12}>
            <CtMultiLineText
              id="txtDiscussion"
              label="Discussion*"
              value={this.state.formData.txtDiscussion}
              handleOnChange={this.handleOnChange}
              width={520}
              maxLength={1000}
              nextCtrlID={"dtpReminderDate"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpReminderDate"
              label="Remainder Date*"
              value={this.state.formData.dtpReminderDate}
              handleOnChange={this.handleOnChange}
              width={180}
              maxLength={100}
              nextCtrlID={"txtRemark"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item xs={12}>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={this.state.formData.txtRemark}
              handleOnChange={this.handleOnChange}
              width={520}
              maxLength={1000}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ color: "text.primary", bold: true }}>
              Document List
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TableList
              columns={this.state.Columns}
              rows={this.state.rows}
              rowsCount={this.state.rows.length}
              rowsPerPage={50}
              handleOnRowDataChange={this.handleOnRowDataChange}
              handleOnColumnChange={this.handleOnColumnChange}
              noMobileLayout={true}
              action
            />
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              marginTop={2}
            >
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveFollowUpEntry}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_followup_srno,
                      this.state.formData.txtPersonName,
                    );
                  }}
                  disabled={
                    this.state.formData.bint_followup_srno > 0 ? false : true
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCFollowUpEntry {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
